<template>
  <div class="OtehrContactAndEnquiry">
          <div class="row OtehrContactAndEnquiryBody"
              v-dragula="Temp_Value" service="OtehrContact" drake="OtehrContact"> 
              <template v-for="(contact, index) in Temp_Value">
              <div class="OtehrContactAndEnquiry_nav" 
              v-if="isContactItemComplete(contact)"
              :key="contact.orderId" 
              :id="contact.orderId" >
                <div class="OtehrContactAndEnquiry_block" @click="OpenContact(index)">
                  <div class="slider">
                      <a href="javascript:;"  ><img :src="cdnURL+'slider.svg'"/></a>
                  </div>
                  <div class="content" >
                    <div class="OfficeTitle">
                      {{
                              langId == 1252 ? contact.nameE
                                ? contact.nameE
                                : contact.nameT
                                ? contact.nameT
                                : contact.nameS
                                ? contact.nameS
                                : $t("lbl_EMPBE_NewContact")
                              : contact.nameT
                                ? contact.nameT
                                : contact.nameE
                                ? contact.nameE
                                : contact.nameS
                                ? contact.nameS
                                : $t("lbl_EMPBE_NewContact")
                              
                            }}
                    </div>
                    <div class="ContactName">
                      {{
                              langId == 1252 ? contact.nameE
                                ? contact.nameE
                                : contact.nameT
                                ? contact.nameT
                                : contact.nameS
                                ? contact.nameS
                                : $t("lbl_EMPBE_NewContact")
                              : contact.nameT
                                ? contact.nameT
                                : contact.nameE
                                ? contact.nameE
                                : contact.nameS
                                ? contact.nameS
                                : $t("lbl_EMPBE_NewContact")
                              
                            }}
                    </div>
                  </div>
                </div>
                <div class="OtehrContactAndEnquiry_Del">
                  <a href="javascript:;" @click="DeleteContact(index)"><img :src="cdnURL+'DelSale_Enquiry.svg'"/></a>
                </div>
              </div>
              </template>
          </div>
           <b-button  v-if="Temp_Value.length<nums"
                    class="btn btn-outline-primary p-l-15 d-flex align-items-center" variant="outline-primary"
                    @click="OpenNewContact"
                     v-bind:t_label="'EMPBE_Other_contract_info_add'">
                    <feather type="plus-circle"> </feather>
                    &nbsp; {{ $t("lbl_EMPBE_CompanyInfo_Contact_OtherContactInfo_Button") }}
                </b-button>

   <div>
      <b-sidebar
        id="ContactRightpopup"
        class="customSidebar"
        title=""
        right
        bg-variant="white"
        backdrop
        :shadow="true"
        ref="ContactRightpopup"
        v-model="ContactRightpopupShow">
        <OtherContactAndEnquiryDetail 
          :detailObject="detailObject"
          :detailIndex="detailIndex"
          :NatureOptions="NatureOptions" 
          :CellCountryOptions="CellCountryOptions"
          :CountryOptions="CountryOptions"
        ></OtherContactAndEnquiryDetail>
      </b-sidebar>
    </div>
  </div>
</template>
<script>
import OtherContactAndEnquiryDetail from "./OtherContactAndEnquiryDetail.vue";
export default {
  props: ["value", "supplierId","nums","NatureOptions","CellCountryOptions","CountryOptions"],
  components: {
    OtherContactAndEnquiryDetail
  },
  data() {
    return {
      ContactRightpopupShow:false,
      rightPopUpInvisible: false,
      detailObject: Object,
      detailIndex: 0,
      cdnURL:"https://cdn.adsalecdn.com/EMP/Backend/svg/CompanyInfo/",
      init_detailObject: {
        orderId:undefined,
        nature: undefined,
        nameE:"",
        nameT:"",
        countryId:undefined,
        addressEng1:"",
        addressTC1:"",
        contactEmail:"",
        ContactPhoneCountry:undefined,
        contactPhoneNumber:"",
        fax:"",
        webSite:""
      },
      Temp_Value:this.value,
    };
  },
  created() {
  },
  computed: {
    langId() {
      return localStorage.getItem("currentLangId");
    },
  },
  watch: {
    value() {
      this.Temp_Value = this.value;
    },
    Temp_Value:{
            handler() 
            {
                this.$emit("input",this.Temp_Value);
            },deep:true
    }
  },
  methods: {
    isContactItemComplete(item) {
      if (!item) {
        return false;
      }
      const nameE = item.nameE != null ? String(item.nameE).trim() : "";
      const addressEng1 = item.addressEng1 != null ? String(item.addressEng1).trim() : "";
      return (
        //item.nature !== undefined && item.nature !== null && item.nature !== "" &&
        //item.countryId !== undefined && item.countryId !== null && item.countryId !== "" &&
        nameE.length > 0 &&
        addressEng1.length > 0
      );
    },
    OpenNewContact() {
      if (this.Temp_Value.length <= this.nums) {
        this.detailObject = Object.assign({}, this.init_detailObject);
        this.detailIndex = -1;
        if (!this.$refs.ContactRightpopup.isOpen) {
          this.$root.$emit("bv::toggle::collapse", "ContactRightpopup");
        }
      }
    },
    OpenContact(index) {
      this.detailObject = this.Temp_Value[index];
      this.detailIndex = index;
      if (!this.$refs.ContactRightpopup.isOpen) {
        this.$root.$emit("bv::toggle::collapse", "ContactRightpopup");
      }
    },
    DeleteContact(index) {
      this.Temp_Value.splice(index, 1);
      if (this.$refs.ContactRightpopup.isOpen) {
        this.$root.$emit("bv::toggle::collapse", "ContactRightpopup");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.OtehrContactAndEnquiryBody{
  .OtehrContactAndEnquiry_nav
  {
    display: flex;
    align-items: center;
    gap: 8px;
    align-self: stretch;
    margin-bottom: 18px;
    width: 100%;
    padding: 0px 15px 0 15px;
    .OtehrContactAndEnquiry_block
    {
      display: flex;
      padding: 16px;
      align-items: center;
      gap: 16px;
      flex: 1 0 0;
      border-radius: 16px;
      border: 1px solid var(--outline-10, rgba(0, 0, 0, 0.10)); 
    }
    .OfficeTitle{
      color: var(--on-surface-60, rgba(0, 0, 0, 0.60));
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 150%; /* 18px */
    }
    .ContactName{
      color: var(--Light-Text-Primary, rgba(0, 0, 0, 0.87));
      font-size: 14px;
      font-style: normal;
      font-weight: 700;
      line-height: 150%; /* 21px */
      letter-spacing: -0.154px;
    }
  }
}

</style>
<style>
h5 {
  font-weight: bold;
}

.tabbed .nav {
  position: absolute;
  left: 22px;
  top: 33px;
  border-bottom: none;
}

.nav-pills .nav-link {
  font-size: 16px;
}
#ContactRightpopup{
width:600px !important; 
min-width:unset !important;
}
</style>
